/**
 * Services Index
 * Central export point for all application services
 */

// Core services
export { authService } from './auth-service.js';
export { apiService } from './api-service.js';
// healthService removed for browser compatibility

// Service initialization helper
export async function initializeServices() {
  // Import services locally to avoid circular dependency issues
  const { authService } = await import('./auth-service.js');
  const { apiService } = await import('./api-service.js');
  
  const services = [
    { name: 'ApiService', service: apiService },
    { name: 'AuthService', service: authService },
    // HealthService excluded from browser builds for Node.js compatibility
  ];

  console.log('Initializing services...');

  for (const { name, service } of services) {
    try {
      if (service.init) {
        await service.init();
        console.log(`✓ ${name} initialized`);
      }
    } catch (error) {
      console.error(`✗ ${name} initialization failed:`, error);
      throw error;
    }
  }

  console.log('All services initialized successfully');
}
